export const companyInfoFields = [
  { name: "policyName", label: "Company Legal Name", required: true },
  { name: "dba", label: "Doing Business As", required: false },
  { name: "companyPhone", label: "Company Phone Number", required: false, type: "tel" },
  { name: "clientFirstName", label: "Client First Name", required: true },
  { name: "clientLastName", label: "Client Last Name", required: true },
  { name: "clientEmail", label: "Client Email", required: true, type: "email" },
  { name: "address1", label: "Address Line 1", required: true },
  { name: "address2", label: "Address Line 2", required: false },
  { name: "city", label: "City/Town", required: true },
  { name: "province", label: "Province", required: true, type: "select" },
  { name: "companyPostal", label: "Postal Code", required: true, type: "text" },
  { name: "brokerName", label: "Advisor Name", required: true },
  {
    name: "brokerEmail",
    label: "Advisor Email",
    required: true,
    type: "email",
  },
];

export const benefitCategoryFields = [
  {
    name: "categoryName",
    label: "Category Name",
    required: true,
    type: "text",
  },
  {
    name: "customCategoryName",
    label: "Custom Category Name",
    required: false,
    type: "text",
  },
  {
    name: "jobDescription",
    label: "Job Description",
    required: true,
    type: "textarea",
  },
  {
    name: "limitSingle",
    label: "Total Annual Limit (Single)",
    required: true,
    type: "number",
  },
  {
    name: "limitCouple",
    label: "Total Annual Limit (Couple)",
    required: true,
    type: "number",
  },
  {
    name: "limitFamily",
    label: "Total Annual Limit (Family)",
    required: true,
    type: "number",
  },
  {
    name: "waitingPeriod",
    label: "Waiting Period",
    required: true,
    type: "number",
  },
  {
    name: "scheduleCredits",
    label: "Schedule Credits",
    required: false,
    type: "checkbox",
  },
  {
    name: "scheduleCreditsFrequency",
    label: "Schedule Credits Frequency",
    required: false,
    type: "text",
  },
  {
    name: "prorateExistingEmployees",
    label: "Prorate Existing Employees",
    required: false,
    type: "checkbox",
  },
  {
    name: "prorateNewHires",
    label: "Prorate New Hires",
    required: false,
    type: "checkbox",
  },
  {
    name: "coverageRate",
    label: "Coverage Rate (%)",
    required: true,
    type: "number",
  },
  {
    name: "allowLsaDependents",
    label: "Allow LSA Dependents",
    required: false,
    type: "checkbox",
  },
  { name: "hasHsa", label: "Has HSA", required: false, type: "checkbox" },
  { name: "hasLsa", label: "Has LSA", required: false, type: "checkbox" },
  { name: "hasRsp", label: "Has RSP", required: false, type: "checkbox" },
  {
    name: "flexDeadlineDate",
    label: "Flex Deadline Date",
    required: false,
    type: "date",
  },
  {
    name: "defaultSelectionSplit",
    label: "Default Selection Split",
    required: false,
    type: "text",
  },
  {
    name: "defaultSelectionNote",
    label: "Default Selection Note",
    required: false,
    type: "textarea",
  },
  {
    name: "limitSingleHSA",
    label: "Total HSA Annual Limit (Single)",
    required: false,
    type: "number",
  },
  {
    name: "limitSingleLSA",
    label: "Total LSA Annual Limit (Single)",
    required: false,
    type: "number",
  },
  {
    name: "limitCoupleHSA",
    label: "Total HSA Annual Limit (Couple)",
    required: false,
    type: "number",
  },
  {
    name: "limitCoupleLSA",
    label: "Total LSA Annual Limit (Couple)",
    required: false,
    type: "number",
  },
  {
    name: "limitFamilyHSA",
    label: "Total HSA Annual Limit (Family)",
    required: false,
    type: "number",
  },
  {
    name: "limitFamilyLSA",
    label: "Total LSA Annual Limit (Family)",
    required: false,
    type: "number",
  },
];

export const accountConfigFields = [
  {
    name: "effectiveDate",
    label: "Effective Date",
    required: true,
    type: "date",
  },
  { name: "startMonth", label: "Start Month", required: true, type: "select" },
  {
    name: "runoffPeriod",
    label: "Runoff Period",
    required: true,
    type: "select",
  },
  {
    name: "carryForward",
    label: "Carry Forward",
    required: true,
    type: "select",
  },
  {
    name: "dependentCutoff",
    label: "Dependent Cutoff Age",
    required: true,
    type: "number",
  },
  {
    name: "dependentStudentCutoff",
    label: "Dependent Student Cutoff Age",
    required: true,
    type: "number",
  },
  {
    name: "flexSelectionLaunchDate",
    label: "Flex Selection Launch Date",
    required: false,
    type: "date",
  },
  {
    name: "flexSelectionDeadline",
    label: "Flex Selection Deadline",
    required: false,
    type: "date",
  },
  {
    name: "fundingOption",
    label: "Funding Option",
    required: true,
    type: "select",
  },
];

export const planAdminFields = [
  { name: "firstName", label: "First Name", required: true, type: "text" },
  { name: "lastName", label: "Last Name", required: true, type: "text" },
  { name: "email", label: "Email", required: true, type: "email" },
];

export const employeeFields = [
  { name: "firstName", label: "First Name", required: true, type: "text" },
  { name: "lastName", label: "Last Name", required: true, type: "text" },
  { name: "maidenName", label: "Maiden Name", required: false, type: "text" },
  { name: "nickName", label: "Nick Name", required: false, type: "text" },
  { name: "email", label: "Email", required: true, type: "email" },
  { name: "birthDate", label: "Birth Date", required: true, type: "date" },
  { name: "hireDate", label: "Hire Date", required: true, type: "date" },
  {
    name: "categoryAssign",
    label: "Benefit Category",
    required: true,
    type: "select",
  },
];

export const dependentFields = [
  { name: "firstName", label: "First Name", required: true, type: "text" },
  { name: "lastName", label: "Last Name", required: true, type: "text" },
  { name: "maidenName", label: "Maiden Name", required: false, type: "text" },
  { name: "nickName", label: "Nick Name", required: false, type: "text" },
  { name: "birthDate", label: "Birth Date", required: true, type: "date" },
  { name: "relation", label: "Relationship", required: true, type: "select" },
  {
    name: "studentTermStart",
    label: "Student Term Start Date",
    required: false,
    type: "date",
  },
  {
    name: "studentTermEnd",
    label: "Student Term End Date",
    required: false,
    type: "date",
  },
];

// PREDEFINED VALUES
export const predefinedDescriptions = {
  Executive:
    "e.g., Has the authority to enter into contracts on behalf of the company and is responsible for the overall direction and vision.",
  Manager:
    "e.g., Is responsible for all hiring and supervision of employees within their areas of responsibility.",
  "All Employees":
    "e.g., All eligible employees, performing daily operational duties as directed.",
  "Full Time":
    "e.g., Performs daily operational duties and works for at least 30 hours a week.",
  "Part Time":
    "e.g., Performs daily operational duties and works for less than 30 hours a week.",
  "Admin Only": "e.g., Plan admins only. No limit assigned.",
};

export const PAY_AS_SUBMITTED_SENTINEL = "Pay As Submitted - All submitted expenses will be reimbursed";

export const lifestyleOptions = [
  "Automobile Expenses - Costs associated with vehicle operation and maintenance",
  "Computer Products/Mobile Devices - Products for personal computing and mobile communication",
  "Cosmetic Procedures - Services related to personal appearance",
  "Cosmetic Products - Products related to personal appearance",
  "Education & Development - Personal Tuition fees for university, college or continuing education. Personal interest classes, life-coaching, tutoring, seminars, workshops, and conferences. Required books, e-books, audiobooks, subscriptions, supplies, or materials for your course or program.",
  "Education & Development - Work Related expenses related to your professional learning, development and growth",
  "Electronics - Headsets only",
  "Electronics - Technological products used to enhance leisure time",
  "Family Assistance - Attendant care and facility costs",
  "Family Leisure Fees - Participation in leisure activities outside of the home",
  "Family Planning - Adoption",
  "First Home Savings Account (FHSA or FHSP)",
  "Fitness Apparel - Specialized clothing used to participate in fitness activities",
  "Fitness Equipment (non-apparel) - Products that improve health and wellbeing",
  "Fitness Related Services - Memberships/Fees that improve fitness and wellbeing",
  "Furniture (Indoor and Outdoor) and Household Appliances",
  "Green Living - Items or services to make your home more earth friendly",
  "Health Related Devices - Devices that support health, or wellbeing",
  "Health Related Services - Alternative health and wellness services",
  "Hobbies - Expenses related to your hobbies and interests",
  "Home Improvements and Renovations - Costs Associated with Upgrading Your Personal Residence(s)",
  "Hot Tubs and Saunas",
  "Hunting & Trapping - Equipment, gear, and apparel",
  "Individual Health Insurance Premiums",
  "Individual Insurance Premiums",
  "Infant Equipment and Furniture, Carriers and Safety Items - Hard goods required for the care and safety of your infant",
  "Life Balance - Supports household responsibilities, allowing for participation in fitness and leisure activities",
  "Life Event Preparation - Professional service fees to help you plan and navigate major life milestones",
  "Musical Instruments and Lessons",
  "Parking Costs (work)",
  "Personal Protective Reflective Clothing",
  "Pet Care and Services",
  "Reading Materials",
  "Recreational Related Services - Memberships/Fees for recreational activities that improve health and wellbeing",
  "Remote Products - Items that support working remotely",
  "RESP Contributions",
  "RRSP Contributions",
  "Safety Eyewear - Vision Protection",
  "Safety Footwear (work)",
  "Safety Work Boots",
  "Spa Services - Services related to relaxation and wellbeing",
  "Student Loan Repayment Program",
  "TFSA Contributions",
  "Transportation (does not include personal automobile expenses) - Costs associated with getting to work",
  "Travel and Vacation",
  "Wellness Products (non-food) - Products used to support a healthy body",
  "Winter Apparel",
  "Work Tools & Equipment",
];